import React, { Component } from 'react';
import { connect } from 'react-redux';
import { selectPane, setSingleMode, setTeamMode, showTeamModal } from "../actions";
import TextPane from '../components/Sidebar/TextPane';
import ImagePane from '../components/Sidebar/ImagePane';
import StickerPane from "../components/Sidebar/StickerPane";
import SponsorPane from "../components/Sidebar/SponsorPane";
import ChoiceWidget from '../components/ChoiceWidget';
import TemplatePane from "../components/Sidebar/TemplatePane";

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.handleSelectText = this.handleSelectText.bind(this);
    this.handleSelectImage = this.handleSelectImage.bind(this);
    this.handleSelectSticker = this.handleSelectSticker.bind(this);
    this.handleSelectSponsor = this.handleSelectSponsor.bind(this);
    this.handleSingleMode = this.handleSingleMode.bind(this);
    this.handleTeamMode = this.handleTeamMode.bind(this);
    this.renderMode = this.renderMode.bind(this);
    this.renderTeamSelector = this.renderTeamSelector.bind(this);
  }

  handleSelectText() {
    this.props.selectPane('text');
  }

  handleSelectImage() {
    this.props.selectPane('image');
  }

  handleSelectSticker() {
    this.props.selectPane('sticker');
  }

  handleSelectSponsor() {
    this.props.selectPane('sponsor');
  }

  handleSingleMode() {
    this.props.setSingleMode();
  }

  handleTeamMode() {
    if (this.props.teams.teams.length === 0) {
      this.props.showTeamModal();
    } else {
      this.props.setTeamMode();
    }
  }

  renderPane() {
    switch (this.props.sidebar.selected) {
      case 'text':
        return <TextPane />;
      case 'image':
        return <ImagePane />;
      case 'sticker':
        return <StickerPane/>;
      case 'sponsor':
        return <SponsorPane/>;
      default:
        return null
    }
  }

  renderMode() {
    if (this.props.sidebar.team) {
      return (<button className="btn btn-md btn-info btn-block no-radius" onClick={this.handleSingleMode}>一般入稿する <i className="fa fa-chevron-right" /></button>);
    } else {
      return (<button className="btn btn-md btn-warning btn-block no-radius" onClick={this.handleTeamMode}>団体入稿する <i className="fa fa-chevron-right" /></button>);
    }
  }

  renderTeamSelector() {
    if (!this.props.sidebar.team) {
      return;
    }

    return (
      <div className="t-container-sidebar-pane">
        <div className="t-container-sidebar-content">
          <h3>団体の選択</h3>
          <ChoiceWidget
            choices={this.props.teams.teams}
            data={this.props.teams.current}
            renderLabel={(value) => {
              return <span>{value.name}</span>;
            }}
            renderChoice={(value) => {
              return <span>{value.name}</span>;
            }}
            onSelect={() => {}}
          />
        </div>
      </div>
    );
  }

  render() {
    if (this.props.system.isTemplate) {
      return (
        <div className="t-container-sidebar">
          <TemplatePane />
        </div>
      );
    }

    return (
      <div className="t-container-sidebar">
        <div className="t-container-sidebar-pane-top">
          <div className="phase-title">
            <small>STEP5</small>
            <span>自由編集</span>
          </div>
        </div>
        <div className="t-container-sidebar-pane t-container-sidebar-pane-top">
          {/*<div className="t-container-button">*/}
          {/*  {this.renderMode()}*/}
          {/*</div>*/}
          {this.renderTeamSelector()}
          <div className="t-container-sidebar-tabs">
            <button className={this.props.sidebar.selected === 'text' ? 'active' : ''} onClick={this.handleSelectText}>
              <img src={window.tProjectGlobals.assetBaseUrl + "img/tab-text-icon.png"} alt=""/>
              <span className="t-container-sidebar-tabs-text">テキスト追加</span>
            </button>
            <button className={this.props.sidebar.selected === 'image' ? 'active' : ''} onClick={this.handleSelectImage}>
              <img src={window.tProjectGlobals.assetBaseUrl + "img/tab-image-icon.png"} alt=""/>
              <span className="t-container-sidebar-tabs-image">ロゴ追加</span>
            </button>

          </div>
        </div>

        {this.renderPane()}
      </div>
    );
  }
}

export default connect(f => f, {selectPane, setSingleMode, setTeamMode, showTeamModal})(Sidebar);



// WEBPACK FOOTER //
// ./src/containers/Sidebar.js